import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { DEFAULT_REPORT_DOWNLOAD_MESSAGE, Status } from "../../../../common/constants";
import api from "../../../../api";
import { generateDeviceReportUrl } from "../../../../config";

interface IDeviceReportExportState {
  status: string;
  error: string | null;
  message?: string;
}

const initialState: IDeviceReportExportState = {
  status: Status.IDLE,
  error: null,
  message: "",
};

export const downloadDeviceReport: any = createAsyncThunk(
  "deviceReport/download",
  async ({ orgId, updateStatus, isFirmware }: any, { rejectWithValue }) => {
    try {
      const url = `${generateDeviceReportUrl}?orgId=${orgId}&updateStatus=${updateStatus}&isFirmware=${isFirmware}`;

      const response = await api.get(url, {
        responseType: "blob",
      });

      return {
        data: response.data,
        headers: response.headers,
      };
    } catch (error: any) {
      try {
        if (error.response?.data instanceof Blob) {
          const text = await error.response.data.text();
          const json = JSON.parse(text);

          return rejectWithValue(json);
        }

        return rejectWithValue(error.response?.data || DEFAULT_REPORT_DOWNLOAD_MESSAGE.FAILED);
      } catch (e) {
        return rejectWithValue(DEFAULT_REPORT_DOWNLOAD_MESSAGE.FAILED);
      }
    }
  }
);

const deviceReportSlice = createSlice({
  name: "deviceReport",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(downloadDeviceReport.pending, (state) => {
        state.status = Status.PENDING;
        state.error = null;
      })
      .addCase(downloadDeviceReport.fulfilled, (state) => {
        state.status = Status.SUCCESS;
        state.message = DEFAULT_REPORT_DOWNLOAD_MESSAGE.SUCCESS;
      })
      .addCase(downloadDeviceReport.rejected, (state, action) => {
        state.status = Status.FAILED;
        state.error =
          action.payload?.data?.error?.message ||
          action.payload?.data?.message || action.payload?.message ||
          DEFAULT_REPORT_DOWNLOAD_MESSAGE.FAILED;
      });
  },
});

export const selector = (store: any) => store["deviceUpdateReport"];
export default deviceReportSlice.reducer;
